module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.status),
      expression: "status"
    }],
    staticClass: "toast-bg",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.toCancel($event)
      }
    }
  }, [_c('img', {
    class: _vm.classes,
    attrs: {
      "src": _vm.imgs,
      "alt": ""
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dae39bfc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/component/others.vue
// module id = 164
// module chunks = 2